(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-custom"] && !Shopify.designMode) return;
  try {
    
  class FeaturedProduct extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.variantSelects = this.querySelectorAll('.featured-product__option-select');
      this.thumbnails = this.querySelectorAll('.featured-product__thumbnail');

      this.setupVariantSelection();
      this.setupThumbnails();
    }

    setupVariantSelection() {
      if (this.variantSelects.length === 0) return;

      this.variantSelects.forEach((select) => {
        select.addEventListener('change', this.onVariantChange.bind(this));
      });
    }

    onVariantChange() {
      const productHandle = this.dataset.productHandle;
      const selectedOptions = Array.from(this.variantSelects).map(select => select.value);

      fetch(`/products/${productHandle}.js`)
        .then(response => response.json())
        .then(product => {
          const variant = product.variants.find(v =>
            v.options.every((opt, idx) => opt === selectedOptions[idx])
          );

          if (variant) {
            this.updateVariant(variant);
          }
        });
    }

    updateVariant(variant) {
      const hiddenInput = this.querySelector('input[name="id"]');
      const submitButton = this.querySelector('.featured-product__submit');
      const priceElement = this.querySelector('.featured-product__price');

      if (hiddenInput) {
        hiddenInput.value = variant.id;
      }

      if (submitButton) {
        submitButton.disabled = !variant.available;
        submitButton.textContent = variant.available
          ? window.variantStrings?.addToCart || 'Add to cart'
          : window.variantStrings?.soldOut || 'Sold out';
      }

      if (priceElement && variant.price) {
        priceElement.innerHTML = Shopify.formatMoney(variant.price);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    setupThumbnails() {
      if (this.thumbnails.length === 0) return;

      this.thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', this.onThumbnailClick.bind(this));
      });
    }

    onThumbnailClick(event) {
      const thumbnail = event.currentTarget;
      const mediaId = thumbnail.dataset.mediaId;

      this.thumbnails.forEach(t => t.classList.remove('featured-product__thumbnail--active'));
      thumbnail.classList.add('featured-product__thumbnail--active');

      // Dispatch custom event for media gallery updates
      this.dispatchEvent(new CustomEvent('featuredproduct:mediachange', {
        detail: { mediaId },
        bubbles: true
      }));
    }
  }

  if (!customElements.get('featured-product')) {
    customElements.define('featured-product', FeaturedProduct);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
